export default "__VITE_ASSET__DxuC3aYi__"